var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.ORDER_ABNORMAL_FIVE_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "default-sort": _vm.defaultSort,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { contentMethod: false, enterable: true },
          selection: _vm.selection,
        },
        on: {
          "sort-change": _vm.sortChange,
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c("BjSelectChannelStore", {
                  attrs: {
                    span: _vm.colSpan,
                    "query-params": _vm.queryParams,
                    "query-props": ["channel", "storeIdList"],
                    multiple: "",
                  },
                }),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("InternalOrder.No"),
                          prop: "orderNo",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t("InternalOrder.No"),
                            comma: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "orderNo", $$v)
                            },
                            expression: "queryParams.orderNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("InternalOrder.order") } },
                      [
                        _c("BjDateRangePicker", {
                          attrs: { placeholder: _vm.$t("InternalOrder.order") },
                          model: {
                            value: _vm.queryParamsTime_order,
                            callback: function ($$v) {
                              _vm.queryParamsTime_order = $$v
                            },
                            expression: "queryParamsTime_order",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CustomerName"),
                              prop: "cusId",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.customerList,
                                placeholder: _vm.$t("customerNameText"),
                              },
                              model: {
                                value: _vm.queryParams.cusId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "cusId", $$v)
                                },
                                expression: "queryParams.cusId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    !_vm.$store.getters.cusId
                      ? _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: {
                              disabled: tableOperationProp.notSelected,
                              type: "primary",
                            },
                            on: { click: _vm.betchPickup },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "InternalSalesOrderDetails.customerDelivery"
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop == "cusId"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerList.bjGet(
                                                scope.row.cusId
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "outerOrderNo"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.webReference)
                                            ),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row.webReference,
                                            },
                                          }),
                                        ]
                                      : col.prop === "totalOrderStatus"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row[col.prop] === 7
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_ALL_STATUS_LIST.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "orderHandleStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                [0, 6].includes(
                                                  scope.row[col.prop]
                                                )
                                                  ? _vm.$t(
                                                      _vm.ORDER_WMS_STATUS_LIST.bjGet(
                                                        scope.row[col.prop]
                                                      )
                                                    )
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "orderStatusStr"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row[col.prop] ===
                                                  "Proccessing"
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "pickUpTime"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row[col.prop] ? "Yes" : ""
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "shippingMethod"
                                      ? [
                                          _c("el-tag", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.CSG_ORDER_SHIPPING_METHODS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "creationDate"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOperateTwoHour")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "failureReason"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.LANG_ZH_EN_PS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "orderTime"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOptimization")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "lastUpdateDate"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOperateTwoHour")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toViewOrder(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                    !_vm.$store.getters.cusId
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "main-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.customerDelivery(
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "InternalSalesOrderDetails.customerDelivery"
                                                )
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    props.row.shippingMethod == "PICKUP"
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: {
                                              disabled: [0, 6].includes(
                                                props.row.orderHandleStatus
                                              ),
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDelete(props.row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("cancelText")))]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("delveryDialog", {
        ref: "delveryDialogRef",
        on: { reFresh: _vm.reFresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }